import { MagnifyingGlass } from "@/components/icons";

const CourseNotStarted = () => {
  return (
    <div className="container flex flex-col items-center justify-center px-4 py-20 text-center">
      <div className="mx-auto max-w-md space-y-4">
        <MagnifyingGlass className="mx-auto h-12 w-12 text-gray-400" />
        <h2 className="text-xl font-bold text-gray-800 lg:text-2xl">
          Your Course Hasn&apos;t Started Yet
        </h2>
        <p className="text-gray-600">
          The course materials will become available once the start date
          arrives.
        </p>
      </div>
    </div>
  );
};

export default CourseNotStarted;
